
import React from 'react'
import { Linking, Platform } from 'react-native'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import { ClientProvider } from '@sart/client'
import { NavigationContainer } from '@react-navigation/native'
import AppConfig from './Configuration'
import { LogBox } from 'react-native';

const Stack = createNativeStackNavigator()

import AppNavigator from './AppNavigator'

export default function App() {
  var prefix = (Platform.OS === 'web' && AppConfig.appPrefix) ? AppConfig.appPrefix : ''

  
  LogBox.ignoreLogs(['Warning: ...']); // Ignore log notification by message
  LogBox.ignoreAllLogs();//Ignore all log notifications

  const linking = {
    prefixes: [
      'bikermobile://'
    ],
    config: {
      screens: {
        AppNavigator: {
          initialRouteName:'Loading',
          path:prefix,
          screens: {
            Loading: 'loading',
            Welcome: 'welcome',
            Unavailable: 'unavailable',
            Help: 'help',
            Sign: {
              screens: {
                SignIn: 'login',
                RegisterNumber: 'registration',
                VerifyNumber: 'register-verify',
                RegisterDetails: 'register-details',
                SetPassword: 'register-password',
                ForgottenPassword: 'forgotten-password',
                ForgottenPasswordAuth: 'forgotten-password-auth',
                ForgottenPasswordNewPassword: 'forgotten-password-new',
                Help: 'login/help',
                SignUpNewCustomerSim: 'new-customer-sim',
                SignUpNewCustomerDetails: 'new-customer-details',
                SignUpNewCustomerOTP: 'new-customer-auth',
                CameraComponent: 'camera',
                RegistrationHome: 'register-home',
                RegisterNewCustomerConfirmation: 'register-confirm',
                NcaScanId: 'id-scan'
              }
            },
            Main: {
              screens:{
                Dashboard: {
                  screens: {
                    Overview:'dashboard',
                    Minutes: 'dashboard/minutes',
                    Data: 'dashboard/data',
                    Texts: 'dashboard/texts',
                    BroadbandData: 'dashboard/fixed-data',
                    Confirmation: 'confirm',
                    ConfirmCancel: 'cancel',
                    ViewCashBarcode: 'dashboard/barcode',
                    ViewBill: 'dashboard/bill',
                    PayBill: 'dashboard/pay-bill',
                    TopUp: 'dashboard/top-up'
                  }
                },
                Addons: {
                  screens:{
                    Addons: 'addons',
                    GroupedAddons: 'addons/group',
                    Checkout:{
                      screens:{
                        Checkout: 'addons/checkout',
                        Payment: 'addons/checkout/payment',
                        Receipt: 'addons/checkout/reciept',
                        Confirmation: 'addons/checkout/confirmation',
                        ProcessingCash: 'addons/checkout/processing-cash',
                        HostedPayment: 'addons/checkout/hosted',
                        CheckoutProcessing: 'addons/checkout/processing'
                      }
                    }
                  }
                },
                Shopping: {
                  screens:{
                    Shopping: 'shopping',
                    Checkout:{
                      screens:{
                        Checkout: 'shopping/checkout',
                        Confirmation: 'shopping/checkout/confirmation',
                        HostedPayment: 'shopping/checkout/hosted',
                        CheckoutProcessing: 'shopping/checkout/processing'
                      }
                    }
                  }
                },
                Plans: {
                  screens: {
                    Plans: 'plans',
                    Checkout: {
                      screens:{
                        Checkout: 'plans/checkout',
                        Payment: 'plans/checkout/payment',
                        Receipt: 'plans/checkout/reciept',
                        Confirmation: 'plans/checkout/confirmation',
                        ProcessingCash: 'plans/checkout/processing-cash',
                        HostedPayment: 'plans/checkout/hosted',
                        CheckoutProcessing: 'plans/checkout/processing'
                      }
                    }
                  }
                },
								Inbox: {
									screens: {
										Inbox: 'inbox',
										DisplayNotification: 'inbox/notification',
										NotificationProvisioning: 'inbox/provisioning',
										NotificationConfirmation: 'inbox/confirmation',
										NotificationError: 'inbox/error'
									}
								},
                GiftSwapMenu: {
                  screens: {
                    GiftSwapMenu:'gift-swap',
                    Transfer: 'gift-swap/recipient',
                    TransferMenu: 'gift-swap/gift',
                    Transform: 'gift-swap/swap',
                    Confirmation: 'gift-swap/confirm'
                  }
                },
                Menu: {
                  screens:{
                    Menu: 'menu',
                    Preferences: 'menu/preferences',
                    Legal: 'menu/legal',
                    LegalItem: 'menu/legal/item',
                    TermsAndConditions: 'menu/terms-and-conditions',
                    TermsAndConditionsItem: 'menu/terms-and-conditions/item',
                    FAQs: 'menu/faq',
                    FAQsItem: 'menu/faq/item',
                    HelpScreen: 'menu/help',
                    Profile: 'menu/profile',
                    Account: 'menu/profile/summary',
                    Identification: 'menu/profile/identification',
                    Address: 'menu/profile/address',
                    Payment: 'menu/profile/payment',
                    Settings: 'menu/settings',
                    Switch: 'menu/profile/switch',
                    Confirmation: 'menu/profile/confirmation',
                    ProfileHostedPayment: 'menu/profile/hosted-payment',
                    ProfilePaymentProcessing:'menu/profile/payment-processing',
                    ProfilePaymentConfirmation: 'menu/profile/payment-confirm'
                  }
                }
              }
            }
          }
        }
      }
    },
    async getInitialURL() {
      //We can use this to handle push notifications properly
      const url = await Linking.getInitialURL()
    }
  }
  return (
    <ClientProvider>
      <SafeAreaProvider>
        <NavigationContainer linking={linking}>
          <Stack.Navigator
            initialRouteName='AppNavigator'
            screenOptions={{
              headerShown:false
            }}
          >
            <Stack.Screen
              name="AppNavigator"
              component={AppNavigator}
            />

          </Stack.Navigator>
        </NavigationContainer>
      </SafeAreaProvider>
    </ClientProvider>
  )
}
